import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
const TOKEN_KEY = "lj_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Resolve a listing image_url (external http OR internal /api/files/...)
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND}${url}`;
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};

export const getMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const getListings = async (featured) => {
  const params = featured === undefined ? {} : { params: { featured } };
  const { data } = await axios.get(`${API}/listings`, params);
  return data;
};

export const getListing = async (id) => {
  const { data } = await axios.get(`${API}/listings/${id}`);
  return data;
};

export const createListing = async (payload) => {
  const { data } = await axios.post(`${API}/listings`, payload, { headers: authHeader() });
  return data;
};

export const updateListing = async (id, payload) => {
  const { data } = await axios.put(`${API}/listings/${id}`, payload, { headers: authHeader() });
  return data;
};

export const deleteListing = async (id) => {
  await axios.delete(`${API}/listings/${id}`, { headers: authHeader() });
};

export const uploadImage = async (fileOrBlob, filename = "photo.jpg") => {
  const form = new FormData();
  form.append("file", fileOrBlob, filename);
  const { data } = await axios.post(`${API}/upload`, form, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
  return data.url;
};

export const getTeam = async () => {
  const { data } = await axios.get(`${API}/team`);
  return data;
};

export const updateTeamMember = async (id, payload) => {
  const { data } = await axios.put(`${API}/team/${id}`, payload, { headers: authHeader() });
  return data;
};

export const logEnquiry = (payload) => {
  // fire-and-forget so the WhatsApp link opens without delay
  axios.post(`${API}/enquiries`, payload).catch(() => {});
};

export const getEnquiries = async () => {
  const { data } = await axios.get(`${API}/enquiries`, { headers: authHeader() });
  return data;
};

export const deleteEnquiry = async (id) => {
  await axios.delete(`${API}/enquiries/${id}`, { headers: authHeader() });
};
